import { render, staticRenderFns } from "./PickerGrade.vue?vue&type=template&id=4b9c0c24&"
import script from "./PickerGrade.vue?vue&type=script&lang=js&"
export * from "./PickerGrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports